export default "__VITE_ASSET__Di1Y7iNR__";